var _style, _defs, _ellipse, _ellipse2, _ellipse3, _mask;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMln(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "logo-circle_svg__e5ojfxdzkgl71",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 473 470",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    className: "flex-none w-40 md:w-64 lg:w-72 xl:w-96 h-40 md:h-64 lg:h-72 xl:h-96 max-w-full",
    width: 473,
    height: 470,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes e5ojfxdzkgl73_to__to{0%,60%{transform:translate(299.623519px,330.25237px)}to{transform:translate(79.206655px,274.591545px)}}@keyframes e5ojfxdzkgl74_to__to{0%,35%{transform:translate(168.927002px,296.314011px)}77.5%,to{transform:translate(365.96632px,313.012259px)}}@keyframes e5ojfxdzkgl75_to__to{0%{transform:translate(251.5px,76.5px)}47.5%,to{transform:translate(119.027238px,134.853682px)}}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill",
    x1: 156.478,
    y1: 0,
    x2: -180.436,
    y2: 19.723,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill-0",
    offset: "0%",
    stopColor: "#6F56FD"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill-1",
    offset: "100%",
    stopColor: "#00CABE"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill-2",
    offset: "100%",
    stopColor: "#00CABE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-circle_svg__e5ojfxdzkgl74-fill",
    x1: -186.115,
    y1: 94.502,
    x2: -248.237,
    y2: -17.301,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl74-fill-0",
    offset: "0%",
    stopColor: "#42F4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl74-fill-1",
    offset: "100%",
    stopColor: "#5D89F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill",
    x1: 175.809,
    y1: 0,
    x2: -202.597,
    y2: 23.239,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill-0",
    offset: "0%",
    stopColor: "#6F56FD"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill-1",
    offset: "100%",
    stopColor: "#00CABE"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill-2",
    offset: "100%",
    stopColor: "#00CABE"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-circle_svg__e5ojfxdzkgl73-filter",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "logo-circle_svg__e5ojfxdzkgl73-filter-blur-0",
    stdDeviation: "40,40",
    result: "result"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-circle_svg__e5ojfxdzkgl74-filter",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "logo-circle_svg__e5ojfxdzkgl74-filter-blur-0",
    stdDeviation: "40,40",
    result: "result"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-circle_svg__e5ojfxdzkgl75-filter",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "logo-circle_svg__e5ojfxdzkgl75-filter-blur-0",
    stdDeviation: "40,40",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill",
    x1: 156.478,
    y1: 0,
    x2: -180.436,
    y2: 19.723,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill-0",
    offset: "0%",
    stopColor: "#6F56FD"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill-1",
    offset: "100%",
    stopColor: "#00CABE"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl73-fill-2",
    offset: "100%",
    stopColor: "#00CABE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-circle_svg__e5ojfxdzkgl74-fill",
    x1: -186.115,
    y1: 94.502,
    x2: -248.237,
    y2: -17.301,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl74-fill-0",
    offset: "0%",
    stopColor: "#42F4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl74-fill-1",
    offset: "100%",
    stopColor: "#5D89F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill",
    x1: 175.809,
    y1: 0,
    x2: -202.597,
    y2: 23.239,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill-0",
    offset: "0%",
    stopColor: "#6F56FD"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill-1",
    offset: "100%",
    stopColor: "#00CABE"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo-circle_svg__e5ojfxdzkgl75-fill-2",
    offset: "100%",
    stopColor: "#00CABE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "logo-circle_svg__e5ojfxdzkgl72",
    mask: "url(#logo-circle_svg__e5ojfxdzkgl76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.624 330.252)",
    style: {
      animation: "e5ojfxdzkgl73_to__to 4000ms linear infinite alternate forwards"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "logo-circle_svg__e5ojfxdzkgl73",
    rx: 194.39,
    ry: 180.984,
    transform: "translate(20.386 -18.98)",
    filter: "url(#logo-circle_svg__e5ojfxdzkgl73-filter)",
    fill: "url(\"#logo-circle_svg__e5ojfxdzkgl73-fill\")",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.927 296.314)",
    style: {
      animation: "e5ojfxdzkgl74_to__to 4000ms linear infinite alternate forwards"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "logo-circle_svg__e5ojfxdzkgl74",
    rx: 177.032,
    ry: 156.717,
    transform: "translate(-8.105 7.175)",
    filter: "url(#logo-circle_svg__e5ojfxdzkgl74-filter)",
    fill: "url(\"#logo-circle_svg__e5ojfxdzkgl74-fill\")",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251.5 76.5)",
    style: {
      animation: "e5ojfxdzkgl75_to__to 4000ms linear infinite alternate forwards"
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "logo-circle_svg__e5ojfxdzkgl75",
    rx: 208.93,
    ry: 185.418,
    transform: "translate(-13.43 11.918)",
    filter: "url(#logo-circle_svg__e5ojfxdzkgl75-filter)",
    fill: "url(\"#logo-circle_svg__e5ojfxdzkgl75-fill\")",
    stroke: "none",
    strokeWidth: 1
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "logo-circle_svg__e5ojfxdzkgl76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo-circle_svg__e5ojfxdzkgl77",
    d: "M472.626 235c0 129.787-105.801 235-236.313 235S0 364.787 0 235 105.801 0 236.313 0s236.313 105.213 236.313 235zm-225.898-90.224c0-17.86 14.478-32.338 32.338-32.338s32.339 14.478 32.339 32.339v93.097h42.282v-67.427c0-10.304 8.353-18.657 18.657-18.657s18.657 8.353 18.657 18.657v67.427h-37.314v74.778c0 11.678-9.467 21.145-21.145 21.145-11.677 0-21.144-9.467-21.144-21.145v-74.777h-64.67v94.313c0 18.547-15.036 33.583-33.583 33.583-18.547 0-33.582-15.036-33.582-33.583v-94.314h67.165v-93.098zm-109.457 30.62c0-11.678 9.467-21.145 21.144-21.145 11.678 0 21.145 9.467 21.145 21.145v62.48h-42.289v-62.48zm-27.363 121.509c15.112 0 27.363-12.251 27.363-27.363v-31.666H82.544v31.666c0 15.112 12.251 27.363 27.364 27.363zm321.469-38.516c0 11.408-9.248 20.656-20.655 20.656-11.408 0-20.655-9.248-20.655-20.656v-20.425h41.31v20.425zM61.885 196.882c-11.407 0-20.655 9.248-20.655 20.655v20.426h41.31v-20.426c0-11.407-9.247-20.655-20.655-20.655z",
    clipRule: "evenodd",
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMln);
export default __webpack_public_path__ + "static/media/MLN.53265b7d9f92f542da325d66262bbbbe.svg";
export { ForwardRef as ReactComponent };